import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "@themesberg/react-bootstrap";

// Module-level bridge so any file can call confirmDialog(message) without
// rendering JSX. ConfirmDialogHost registers itself on mount.
let openDialog = null;

export function confirmDialog(
  message,
  { title = "Please confirm", confirmText = "Confirm", cancelText = "Cancel" } = {}
) {
  return new Promise((resolve) => {
    // Fail closed: if no host is mounted, treat as cancelled.
    if (!openDialog) {
      resolve(false);
      return;
    }
    openDialog({ message, title, confirmText, cancelText, resolve });
  });
}

export default function ConfirmDialogHost() {
  const [request, setRequest] = useState(null);
  const pendingRef = useRef(null);

  useEffect(() => {
    openDialog = (req) => {
      // A new request supersedes an open one; cancel the old promise.
      if (pendingRef.current) pendingRef.current.resolve(false);
      pendingRef.current = req;
      setRequest(req);
    };
    return () => {
      openDialog = null;
    };
  }, []);

  const close = (result) => {
    if (pendingRef.current) {
      pendingRef.current.resolve(result);
      pendingRef.current = null;
    }
    setRequest(null);
  };

  return (
    <Modal show={!!request} onHide={() => close(false)} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title className="h6">{request?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{request?.message}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => close(false)}>
          {request?.cancelText}
        </Button>
        <Button variant="primary" onClick={() => close(true)}>
          {request?.confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
